import type { RoomView } from '@v2/multiplayer'
import type { TableNotification } from '@v2/react'
import type { ConnectionStatus } from './network'

export function roomNotifications(room: RoomView, status: ConnectionStatus): TableNotification[] {
  const notifications: TableNotification[] = []
  if (status !== 'connected') {
    notifications.push({ id: 'connection', level: 'warning', title: status === 'offline' ? 'You’re offline' : 'Reconnecting to your table',
      message: 'Your table is saved. Play will be available when the connection returns.', busy: status !== 'offline' })
    // A disconnected room snapshot cannot tell us whether the AI is still waiting.
    return notifications
  }
  if (room.phase !== 'playing') return notifications
  if (room.history?.canRedo && !room.history.request) {
    const active = room.members.find(member => member.playerId === room.projection?.activePlayer)
    notifications.push({ id: 'history-hold', level: 'warning', placement: 'alert',
      title: active?.kind === 'bot' ? `Bot play is paused · ${active.name}’s turn` : 'Play is paused at an earlier position',
      message: 'You went back a move. Resume to keep playing from here, or go forward to restore the undone moves.' })
    return notifications
  }
  if (room.takeover) {
    const name = room.members.find(member => member.playerId === room.takeover)?.name ?? 'the bot'
    notifications.push({ id: 'takeover', level: 'info', placement: 'alert', title: `You’re playing ${name}’s turn`, message: 'Give the turn back when you want the AI to continue.' })
  } else if (!room.history?.request) {
    const name = room.members.find(member => member.playerId === room.bot.playerId)?.name ?? 'The AI'
    if (room.bot.state === 'waiting') notifications.push({ id: 'bot', level: 'warning', title: 'The AI service is busy or temporarily unavailable',
      message: `${name} can’t make a move yet. We’ll retry automatically and resume play when it responds.`, busy: true, retryAt: room.bot.retryAt })
    if (room.bot.state === 'thinking') notifications.push({ id: 'bot', level: 'info', title: `${name} is thinking`, busy: true })
    if (room.bot.state === 'paused') notifications.push({ id: 'bot', level: 'warning', title: 'Bot play is paused',
      message: room.bot.message ?? 'The table leader can resume the bots or play this turn.' })
  }
  return notifications
}
